import { BarChart3 } from 'lucide-react';

import type { Device } from '@/entities/device';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

import {
  PageActionItem,
  PageActionItemButton,
  PageActionItemDescription,
} from './page-actions';

export type PageActionBenchmarkProps = {
  device: Device | null;
};

export function PageActionBenchmark({ device }: PageActionBenchmarkProps) {
  const featureFlag = useFeatureFlag();

  if (!featureFlag('assets') || !device) {
    return null;
  }

  return (
    <PageActionItem>
      <PageActionItemDescription>
        Compare units in the <span className="font-semibold">Benchmark</span>
      </PageActionItemDescription>
      <PageActionItemButton
        data-testid="page-action-benchmark-button"
        to={{
          pathname: '/benchmark',
          search: new URLSearchParams({
            [`${device.level}_id`]: device.fullFrontendId,
          }).toString(),
        }}
        icon={BarChart3}
      >
        Benchmark
      </PageActionItemButton>
    </PageActionItem>
  );
}
